<script>
    export let link;
    function openLink() {
        window.open(link);
    }
</script>

<button on:click={openLink}><img src="assets/appStoreBadge.png" alt="{link}"/></button>

<style>
    button {
        background-color: transparent;
        border: none;
    }
    img {
        width: 300px;
        margin-top: 12px;
        transition: 300ms ease-in-out;
    }
    img:hover {
        scale: 1.1;
        cursor: pointer;
        transition: 300ms ease-in-out;
    }

</style>